<template>
  <el-select
    v-model="productId"
    filterable
    remote
    clearable
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="handleChange">
    <el-option
      v-for="item in options"
      :key="item.productId"
      :label="item.productName"
      :value="item.productId">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'EntAutoSelect',
  components: {},
  props: {
    value: {
      // type: [Number, null],
      required: true
    },
    placeholder: {
      type: String,
      default: '请输入产品名称'
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      options: []
    }
  },
  computed: {
    productId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange() {
      this.callback && this.callback()
    },
    remoteMethod(query) {
      if (query) {
        this.loading = true
        this.$store.dispatch('account/getproducts', {
          payload: {
            pageNum: 1,
            pageSize: 10000,
            productName: query
          },
          success: (res) => {
            this.loading = false
            this.options = res.data.records
          },
          fail: () => {
            this.loading = false
            this.options = []
          }
        })
      } else {
        this.options = []
      }
    }
  }
}
</script>
<style lang="stylus" scoped></style>
